import './App.css';
import whiteArrow from './imgs/arrow-white.png';

/**
 * Renders an external link as either a text link or a button-style link.
 * 
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.link - The URL for the external link.
 * @param {string} props.label - The text to display for the link.
 * @param {boolean} props.isButtonStyle - Determines if the link should be styled as a button.
 * @returns {JSX.Element} A React component that renders an anchor tag with the specified properties.
 */
function ExternalTextLink(props) {

  return (
    <>
      <a href={props.link} target="_blank" rel="noopener noreferrer" className={props.isButtonStyle ? "default-button next-button" : "text-link"}>{props.label} {props.isButtonStyle && <img src={whiteArrow} alt="" width="18" height="15" className="white-arrow"/>}</a>
    </>
  );
}

export default ExternalTextLink;